"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapOfferItem = void 0;
var _productBox = require("@ori/product-box");
/**
 * Map offerItems and products to object with attributes that are really needed.
 */ const mapOfferItem = (param)=>{
    let { offerItem, products, isAnonymousUser } = param;
    const productBoxData = products.find((product)=>product.productCode === offerItem.itemCode);
    const productBox = productBoxData ? (0, _productBox.mapProductBoxPropsFromStaticApi)({
        data: productBoxData,
        isAnonymousUser
    }) : null;
    return productBox ? {
        amount: offerItem.amount,
        quantity: offerItem.quantity,
        itemCode: offerItem.itemCode,
        maxQuantityToBuy: offerItem.maxQuantityToBuy,
        originalPrice: offerItem.originalPrice,
        points: offerItem.points,
        price: offerItem.price,
        productBox: {
            ...productBox,
            labels: (0, _productBox.mapLabels)(productBoxData === null || productBoxData === void 0 ? void 0 : productBoxData.labels, {
                ppa: [
                    'NotSoldOnline'
                ]
            })
        }
    } : null;
};
exports.mapOfferItem = mapOfferItem;
